import { Outlet } from 'react-router-dom';
import { FC } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { Loader } from '@shared/ui';
import { Header, Sidebar } from '@widgets/index';

import { useAuth } from '@entities/user';
import { containerStyle } from './MainLayout.tailwind';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      staleTime: 0,
      cacheTime: 0,
      retry: 0,
    },
  },
});

const MainLayout = () => {
  const { isLoading, isAuth } = useAuth();

  return isLoading ? <Loader /> : <LayoutView isAuth={isAuth} />;
};

const LayoutView: FC<{ isAuth: boolean }> = ({ isAuth }) => {
  return (
    <>
      <Header />

      {isAuth ? (
        <>
          <QueryClientProvider client={queryClient}>
            <div className={containerStyle}>
              <Sidebar />
              <Outlet />
            </div>
          </QueryClientProvider>
        </>
      ) : (
        <Outlet />
      )}
    </>
  );
};

export default MainLayout;
